/**
 * @file Web Gallery Blog Toolbar component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { getWebGalleryEntityPath } from '../utilities/web-galleries';
import Angle from '../../../components/global/Angle';

const propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }),
  backUrl: PropTypes.string,
};
const WebGalleryBlogToolbar = ({ entity, backUrl }) => {
  if (!entity) {
    return null;
  }

  const linkTo = backUrl || getWebGalleryEntityPath(entity);

  return (
    <div className="toolbar sticky-top">
      <div className="toolbar-left">
        <Link to={linkTo} className="d-inline-flex btn-body-back">
          <Angle direction="left" className="mr-1" /> Back
        </Link>
      </div>
      <div className="toolbar-center-fixed ">
        <span className="p-1 text-sm">
          Blog posts in <strong>{entity.name}</strong>
        </span>
      </div>
    </div>
  );
};

WebGalleryBlogToolbar.propTypes = propTypes;

export default WebGalleryBlogToolbar;
